import React from 'react';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import cn from 'classnames';

export interface ILeadBannerProps extends IBaseElementProps {
	leadText?: string;
	image?: IImage;
}

/**
 * Lead Banner
 * @block
 * @icon welcome-widgets-menus
 */
const LeadBanner: React.FC<ILeadBannerProps> = ({
	id,
	className,
	classNames = [],
	leadText,
	image,
}) => {
	return (
		<div
			id={id}
			className={className || cn('lead-banner__container', ...classNames)}
		>
			<div className="lead-banner__container-inner">
				<div className="lead-banner__left">
					{leadText && <p>{leadText}</p>}
				</div>
				<div className="lead-banner__right">
					{image?.src?.length > 0 && <Image {...image} />}
				</div>
			</div>
		</div>
	);
};

export default LeadBanner;
